import { useEffect, useState } from "react";

const images = (list) => Array.from(list || []).filter((f) => f && (f.type?.startsWith("image/") || /\.(heic|heif)$/i.test(f.name || "")));

// D1 · Fotos arrastradas sobre la zona o pegadas con Ctrl+V. onFiles recibe solo imágenes.
export function usePhotoDropPaste(onFiles, enabled = true) {
  const [dragging, setDragging] = useState(false);

  useEffect(() => {
    if (!enabled) { return undefined; }
    const onPaste = (e) => {
      const files = images(Array.from(e.clipboardData?.items || []).filter((i) => i.kind === "file").map((i) => i.getAsFile()));
      if (!files.length) return;
      e.preventDefault();
      onFiles(files);
    };
    window.addEventListener("paste", onPaste);
    return () => { window.removeEventListener("paste", onPaste); };
  }, [onFiles, enabled]);

  const dropProps = enabled ? {
    onDragOver: (e) => { e.preventDefault(); setDragging(true); },
    onDragLeave: () => setDragging(false),
    onDrop: (e) => {
      e.preventDefault();
      setDragging(false);
      const files = images(e.dataTransfer?.files);
      if (files.length) onFiles(files);
    },
  } : {};

  return { dragging, dropProps };
}
